import { useState } from 'react'

import { useQuery } from 'react-query'

import { InvestmentEntity } from '@cash-web/protos/squareup/cash/marketdata/model/investment_entities.pb'
import {
  GetAllInvestmentEntitiesResponse,
  InvestmentEntityField,
} from '@cash-web/protos/squareup/cash/marketdata/server/market_data_service.pb'
import { getAllInvestmentEntities } from '@cash-web/shared-data-access-api/api'

type UseQueryGetAllInvestmentEntitiesParams = {
  entityFields?: InvestmentEntityField[]
  enabled?: boolean
}
const DEFAULT_ENTITY_FIELDS = [
  InvestmentEntityField.TOKEN,
  InvestmentEntityField.SYMBOL,
  InvestmentEntityField.DISPLAY_NAME,
  InvestmentEntityField.TYPE,
  InvestmentEntityField.ICON_URL,
  InvestmentEntityField.STATUS,
  InvestmentEntityField.VISIBILITY,
  InvestmentEntityField.TRADABILITY,
  InvestmentEntityField.RELEASE_STAGE,
]

export const useQueryGetAllInvestmentEntities = ({
  entityFields = DEFAULT_ENTITY_FIELDS,
  enabled = true,
}: UseQueryGetAllInvestmentEntitiesParams) => {
  const [isLoading, setIsLoading] = useState(true)
  const [page, setPage] = useState('')
  const [allInvestmentEntities, setAllInvestmentEntities] = useState<InvestmentEntity[]>([])

  const { isError, isFetching, refetch } = useQuery<GetAllInvestmentEntitiesResponse>({
    queryKey: ['getAllInvestmentEntities', entityFields.join(','), page],
    queryFn: () =>
      getAllInvestmentEntities({
        entity_fields: entityFields,
        newest_token: page,
      }),
    enabled,
    keepPreviousData: true,
    onSuccess: data => {
      if (page !== data?.next_request?.newest_token) {
        const newEntities = [...allInvestmentEntities, ...(data?.entities ?? [])]
        const uniqueEntities = [...new Set(newEntities)]
        setAllInvestmentEntities(uniqueEntities)
        if (data?.next_request?.newest_token) {
          setPage(data?.next_request?.newest_token)
        } else {
          setIsLoading(false)
        }
      }
    },
  })

  // The internal flag only clears in onSuccess, which never fires while disabled or after a failed request.
  return {
    allInvestmentEntities,
    isError,
    isLoading: enabled && isLoading && (!isError || isFetching),
    refetch,
  }
}
